import 'bootstrap/js/dist/util'
import 'bootstrap/js/dist/collapse'
import AnimationHelper from '../core/animation-helper'

export default class NavigationMenus {

  constructor () {
    this.mainHeader = document.querySelector('#main-header')
    this.searchForm = this.mainHeader.querySelector('.search-form')
    this.searchFormToggle = this.mainHeader.querySelector('#main-menu-search > a')

    if (this.mainHeader) {
      this.addMenuDropdowns(this.mainHeader.querySelectorAll('nav > .menu'))
      this.addSearchRevealHandler()

      this.escapeKeyListener = this.handleEscapeKeyPress.bind(this)
    }
  }

  handleEscapeKeyPress (e) {
    if (e.key === 'Escape') {
      this.hideSearch()
    }
  }

  addMenuDropdowns (allMenus) {
    allMenus.forEach((menu) => {
      menu.querySelectorAll('.menu-item.menu-item-has-children').forEach((menuItem) => {
        const subMenuContainer = menuItem.querySelector('.sub-menu-container')

        hoverintent(
            menuItem, // element
            this.showMegaMenu(subMenuContainer, menuItem), // In
            this.hideMegaMenu(menuItem, subMenuContainer) // Out
        )
            .options({
              timeout: 150
            })
      })
    })
  }

  hideMegaMenu (menuItem, subMenuContainer) {
    return () => {
      if (window.innerWidth <= 990) {
        return
      }

      menuItem.classList.remove('active')

      this.animationTimer = setTimeout(() => {
        if (subMenuContainer) {
          subMenuContainer.style.display = 'none'
        }
      }, 200)
    }
  }

  showMegaMenu (subMenuContainer, menuItem) {
    const self = this

    return function () {
      if (window.innerWidth <= 990) {
        return
      }

      if (self.animationTimer) {
        clearTimeout(self.animationTimer)
      }

      if (subMenuContainer) {
        subMenuContainer.style.display = 'flex'

        const nestedSubMenus = subMenuContainer.querySelectorAll('.sub-menu .sub-menu')
        nestedSubMenus.forEach((submenu) => {
          submenu.style.display = ''
        })
      }

      self.animationTimer = setTimeout(() => {
        menuItem.classList.add('active')
      }, 10)
    }
  }

  showSearch () {
    AnimationHelper.triggerAnimation(this.searchForm, 'active', 'in')

    this.searchFormToggle.ariaExpanded = true

    this.searchForm.querySelector('.search-field').focus()

    window.addEventListener('keydown', this.escapeKeyListener)
  }

  hideSearch () {
    AnimationHelper.triggerAnimation(this.searchForm, 'active', 'out', 200)

    this.searchFormToggle.ariaExpanded = false

    window.removeEventListener('keydown', this.escapeKeyListener)

    this.searchFormToggle.focus()
  }

  addSearchRevealHandler () {
    this.searchFormToggle.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (this.searchForm.classList.contains('active')) {
        this.hideSearch()
      }

      else {
        this.showSearch()
      }
    })

    document.addEventListener('click', (e) => {
      if (!this.searchForm.contains(e.target) && this.searchForm.classList.contains('active')) {
        this.hideSearch()
      }
    })
  }

}
